import { useState } from "react";

// ── Página Contáctenos ──────────────────────────────────────────────────
// NOTA: este componente es un punto de partida funcional. Si ya tienes un
// formulario propio dentro de src/components/form, reemplaza este archivo
// por el import de ese componente en lugar de este placeholder.
const Contacto = () => {
  const [form, setForm] = useState({ nombre: "", email: "", mensaje: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Formulario de contacto enviado:", form);
  };

  return (
    <div className="container my-5">
      <h2 className="mb-4">Contáctenos</h2>
      <form onSubmit={handleSubmit} style={{ maxWidth: "520px" }}>
        <div className="mb-3">
          <label className="form-label">Nombre</label>
          <input
            type="text"
            name="nombre"
            className="form-control"
            value={form.nombre}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Correo electrónico</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Mensaje</label>
          <textarea
            name="mensaje"
            className="form-control"
            rows="4"
            value={form.mensaje}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-secondary">
          Enviar
        </button>
      </form>
    </div>
  );
};

export default Contacto;